<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.procedimentosFeridas"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(codigo)="{item}">
                {{formatProcedimento(item.procedimento.codigo)}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${formatCid(item.cid.codigo)} - ${item.cid.nome}` : null}}
            </template>

             <template v-slot:cell(quantidade)="{item}">
                {{item.cid ? item.quantidade : ' - '}}
            </template>

            <template v-slot:cell(actions)="{item, index}">
                <rkm-button
                    @click="$emit('edit', item)"
                    color="primary"
                    small
                    title="Editar"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="$emit('remove', item, index)"
                    color="danger"
                    small
                    title="Excluir"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import {formats} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {key: 'codigo', label: 'Código', sortable: true},
            {key: 'procedimento.nome', label: 'Nome', sortable: true},
            {key: 'cid', label: 'CID', sortable: true},
            {class: 'col-min', key: 'quantidade', label: 'Quantidade', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
    },
}
</script>
